import styled from 'styled-components';
import { riseIn } from '@shared/theme/animations';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th {
    text-align: left;
    padding: ${({ theme }) => theme.spacing(3)} ${({ theme }) => theme.spacing(4)};
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: ${({ theme }) => theme.colors.text.secondary};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.surface};
    position: sticky;
    top: 0;
    z-index: 1;
  }

  td {
    padding: ${({ theme }) => theme.spacing(3.5)} ${({ theme }) => theme.spacing(4)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  tbody tr {
    animation: ${riseIn} 320ms ${({ theme }) => theme.motion.easeOut} both;
    transition: background ${({ theme }) => theme.motion.fast}
      ${({ theme }) => theme.motion.easeOut};
  }

  tbody tr:hover {
    background: ${({ theme }) => theme.colors.surface};
  }

  tbody tr:nth-child(1) {
    animation-delay: 0ms;
  }
  tbody tr:nth-child(2) {
    animation-delay: 40ms;
  }
  tbody tr:nth-child(3) {
    animation-delay: 80ms;
  }
  tbody tr:nth-child(4) {
    animation-delay: 120ms;
  }
  tbody tr:nth-child(5) {
    animation-delay: 160ms;
  }
  tbody tr:nth-child(6) {
    animation-delay: 200ms;
  }
  tbody tr:nth-child(7) {
    animation-delay: 240ms;
  }
  tbody tr:nth-child(8) {
    animation-delay: 280ms;
  }
`;
